import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonComponentsModule } from '../../modules/components/common/common.module';
import { SystemNotificationsService } from './system-notifications.provider';
import { SystemNotificationsComponent } from './system-notifications.component';

@NgModule({
  declarations: [SystemNotificationsComponent],
  imports: [CommonModule, CommonComponentsModule],
  exports: [SystemNotificationsComponent],
  providers: [SystemNotificationsService],
})
export class SystemNotificationsModule {}
